import {ApckPropertyTable} from "../common/property_table";
import {ApckColumn} from "../../main";
import AjaxUtils from "../../util/ajax_utils";


const lookup = {
    CUSTOM: 'Custom',
    EMAIL_PASSWORD: 'Email/Password',
    USERNAME_PASSWORD: 'Username/Password',
    JWT: 'JSON Web Token',
    HEADER_VALUE: 'Header/Value',
    KEY_TOKEN: 'Key or Token',
}


export const ApckCredentialTitleColumn = /*#__PURE__*/ ApckColumn.extend({
    computed: {
        value() {
            return lookup[this._raw] || '';
        },
    },
    template: `
        <apck-col-wrapper>
            {{ value }}
        </apck-col-wrapper>
    `
});


export const ApckCredentialDetails = {
    components: {
        'apck-property-table': ApckPropertyTable,
    },
    props: {
        credential: Object
    },
    computed: {
        fields() {
            const fields = [];
            for (const [key, value] of Object.entries(this.credential.credential)) {
                fields.push({
                    "key": key,
                    "value": value,
                    "type": "text",
                    "is_property": true,
                    "edit": false
                })
            }
            return fields;
        },
        displayType() {
            return lookup[this.credential.type];
        },
    },
    methods: {
        closeModal() {
            this.$emit('close');
        }
    },
    template: `
    <div class="lightbox-outer">
        <div class="credential-details lightbox-inner">
            <p><b>{{ displayType }} "{{ credential.description }}"</b></p>

            <div class="credential-details-table"
                 style="display: grid; grid-template-columns: 100px 1fr; gap: 16px 5px; align-items: center; padding-top: 16px; margin-top: 16px; border-top: solid 1px #E2E8F0;"
            >
                <template v-for="(value, field, index) in credential.credential">
                    <label style="font-weight: 500; color: #64748B; padding-right: 0;"
                    >{{ field | title }}</label>
                    <ui-input-text
                        :modelValue="value"
                        :readonly="true"
                        :hideLabel="true"
                    />
                </template>
            </div>
        </div>
    </div>
    `
}

export const CredentialManagerTable = {
    props: {
        src: {
            type: String,
            default: null
        },
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            cols: [
                {"minWidth": 180, "data": "description", "heading": "Description", "canSearch": true, "direction": "desc"},
                {"width": 180, "data": "type", "heading": "Type", "canSearch": true, "ctype": "credtitlecolumn", "direction": ""},
                {"width": 170, "data": "created_at", "heading": "Created", "ctype": "datecolumnnew", "hidden": true, "direction": ""},
                {"width": 170, "data": "updated_at", "heading": "Updated", "ctype": "datecolumnnew", "direction": ""},
                {"width": 170, "data": "expiry_date", "heading": "Expiry Date", "ctype": "dateonlycolumn"},
                {"width": 80, "data": "is_active", "heading": "Active", "ctype": "boolcolumn"},
                {"width": 80, "data": "used_count", "heading": "Usage", "ctype": "column"},
            ],
            actions: [{
                title: "View details",
                icon: "fa-eye",
                class: "btn-primary",
                handler: this.viewCred,
            }, {
                title: "Edit",
                icon: "fa-pencil",
                class: "btn-secondary",
                handler: this.editCred,
            }, {
                title: "Delete",
                icon: "fa-trash",
                class: "btn-negative",
                handler: this.deleteCred,
            }],
            activeTypeFilter: 'ALL',
            activeStatusFilter: 'ALL',
            typeFilters: [
                {name: 'All', value: 'ALL'},
                {name: 'Custom', value: 'CUSTOM'},
                {name: 'Email/Password', value: 'EMAIL_PASSWORD'},
                {name: 'Username/Password', value: 'USERNAME_PASSWORD'},
                {name: 'JSON Web Token', value: 'JWT'},
                {name: 'Header/Value', value: 'HEADER_VALUE'},
                {name: 'Key or Token', value: 'KEY_TOKEN'},
            ],
            statusFilters: [
                {name: 'All', value: 'ALL'},
                {name: 'Active', value: 'ACTIVE'},
                {name: 'Inactive', value: 'INACTIVE'},
            ],
        };
    },
    mounted: function () {
        var store = this.$refs.table.store;
        if (store) {
            this.store = store;
        }
    },
    methods: {
        setTypeFilters(value) {
            this.activeTypeFilter = value;
            this.applyFilters();
        },
        setStatusFilter(value) {
            this.activeStatusFilter = value;
            this.applyFilters();
        },
        applyFilters() {
            const params = {
                offset: this.store.start,
                page_size: this.store.limit,
                page: this.store.getPage(),
                dir: this.store.dir,
                sort: this.store.sort,
                type: this.activeTypeFilter,
                status: this.activeStatusFilter,
            };
            this.store.load(params);
        },
        viewCred: function (row) {
            const cmp = this;
            const _viewCred = function(passwordValue, failureMessage) {
                AjaxUtils.ajax_post({
                    url: '/credman/credentials_secret/' + row.raw.uuid,
                    data: {
                        password: passwordValue,
                    },
                    success: function (resp) {
                        if (!resp.success) {
                            cmp.$dialog.alert(failureMessage, 'Failed');
                            return;
                        }

                        cmp.$lightbox.open({
                            title: "Credential Details",
                            component: ApckCredentialDetails,
                            bind: {
                                credential: resp.data,
                            },
                        });

                    },
                    opts: {
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                });
            }

            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
            } else if (this.skip_password_check) {
                _viewCred(null, "Failed to load credential, please try again.");
            } else {
                this.$dialog.promptPassword("Please enter your AppCheck login password to view the credential.", "Password", '', function (passwordValue) {
                    _viewCred(passwordValue, "Your password was incorrect, please try again.");
                });
            }
        },
        editCred(row) {
            if (this.$globalFlags.spa) {
                // todo: this.$router.push({})
            } else {
                window.location.href = `/credman/credentials/${row.raw.uuid}/update`;
            }
        },
        deleteCred: function (row) {
            const cmp = this;
            const _deleteCred = function(passwordValue, failureMessage) {
                AjaxUtils.ajax_post({
                    url: `/credman/credentials/${row.raw.uuid}/delete`,
                    data: {
                        password: passwordValue,
                    },
                    success: function (resp) {
                        if (!resp.success) {
                            cmp.$dialog.alert(failureMessage, 'Failed');
                            return;
                        }

                        cmp.$refs.table.store.reload();
                        cmp.$flash({message: 'Successfully deleted credential'});
                    },
                    opts: {
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                });
            }

            if (this.not_shared) {
                cmp.$dialog.alert('Organisation has not shared credential access', 'Failed');
            } else if (this.skip_password_check) {
                _deleteCred(null, "Failed to delete, please try again.");
            } else {
                this.$dialog.promptPassword("Please enter your AppCheck login password to delete the credential.", "Password", '', function (passwordValue) {
                    _deleteCred(passwordValue, "Your password was incorrect, please try again.");
                });
            }
        },
     },
    template: `
        <apck-table
            ref="table"
            tableId="all-creds-table"
            :columns="cols"
            :actions="actions"
            :limit="30"
            :new-style-table="true"
            :showColumnPicker="true"
            :sglRowAction="viewCred"
            :show_error_flash="true"
            src="/credman/credentials"
        >
            <template v-slot:tbarBtnGroup>
                <apck-dropdown-button
                    icon="fa-regular fa-filter"
                    :showCaret="false"
                    :closeOnSelect="true"
                    :value="typeFilters.find((el) => el.value === activeTypeFilter).name"
                >
                    <ul>
                        <li class="header">Status</li>
                        <li v-for="filter in statusFilters"
                            @click="setStatusFilter(filter.value)"
                            :class="[filter.value === activeStatusFilter ? 'active' : '']"
                        >
                            <span>{{ filter.name }}</span>
                        </li>
                    </ul>
                    <span class="divider"></span>
                    <ul>
                        <li class="header">Type</li>
                        <li v-for="filter in typeFilters"
                            @click="setTypeFilters(filter.value)"
                            :class="[filter.value === activeTypeFilter ? 'active' : '']"
                        >
                            <span>{{ filter.name }}</span>
                        </li>
                    </ul>
                </apck-dropdown-button>
            </template>
        </apck-table>
    `
}


export const CredentialManagerSSR = {
    props: {
        sidebar: {
            type: Boolean,
            default: true,
        },
        newCredUrl: {
            type: String,
            default: '/credman/credentials/create'
        },
        skip_password_check: {
            type: Boolean,
            default: false,
        },
        not_shared: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        addCredential() {
            window.location.href = this.newCredUrl;
        }
    },
    template: `
        <apck-layout class="new-layout">
            <apck-titlebar title="Credentials">
                <template v-slot:actions>
                    <apck-button
                        icon="fa-regular fa-plus-circle"
                        class="title-button btn-primary"
                        :handler="addCredential"
                        title="Add Credential"
                        value="Add Credential"
                    />
                </template>
            </apck-titlebar>

            <apck-cred-man-table
                v-bind="$props"
            />

            <template v-slot:sidebar v-if="sidebar">
                <apck-side-portal />
            </template>
        </apck-layout>
    `
}
